/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AnalyticsQueryPayload,
  AnalyticsQueryPayload$Outbound,
  AnalyticsQueryPayload$outboundSchema,
} from "../components/analyticsquerypayload.js";

export type AnalyticsQuerySecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type AnalyticsQueryRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  analyticsQueryPayload: AnalyticsQueryPayload;
};

/** @internal */
export type AnalyticsQuerySecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AnalyticsQuerySecurity$outboundSchema: z.ZodMiniType<
  AnalyticsQuerySecurity$Outbound,
  AnalyticsQuerySecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function analyticsQuerySecurityToJSON(
  analyticsQuerySecurity: AnalyticsQuerySecurity,
): string {
  return JSON.stringify(
    AnalyticsQuerySecurity$outboundSchema.parse(analyticsQuerySecurity),
  );
}

/** @internal */
export type AnalyticsQueryRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AnalyticsQueryPayload: AnalyticsQueryPayload$Outbound;
};

/** @internal */
export const AnalyticsQueryRequest$outboundSchema: z.ZodMiniType<
  AnalyticsQueryRequest$Outbound,
  AnalyticsQueryRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    analyticsQueryPayload: AnalyticsQueryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      analyticsQueryPayload: "AnalyticsQueryPayload",
    });
  }),
);

export function analyticsQueryRequestToJSON(
  analyticsQueryRequest: AnalyticsQueryRequest,
): string {
  return JSON.stringify(
    AnalyticsQueryRequest$outboundSchema.parse(analyticsQueryRequest),
  );
}
